// extracted by mini-css-extract-plugin
export default {"content":"setPinContent_content__Iq4Cf","label":"setPinContent_label__D-gto","labelSpaced":"setPinContent_labelSpaced__q+8ND","btnWrapper":"setPinContent_btnWrapper__oTPGU"};